import './dashCompareChart.css';
import Chart from "../../../shared/chart/chart";
import {useEffect, useState} from "react";
const DashCompareChart = () => {
    const [data, setData] = useState();
    useEffect(() => {
        setData( {
            datasets:  [
                {
                    label: 'Road Alerts',
                    backgroundColor: "#CDD7DA",
                    data: [35, 45, 35, 35, 40, 45, 35, 45],

                },
                {
                    label: 'Cabin Alerts',
                    backgroundColor: ["#7BCC92", '#F07979', "#7BCC92", '#F07979', "#7BCC92", "#7BCC92", '#F07979', '#F07979'],
                    data: [25, 30, 25, 20, 30, 30, 25, 35],

                },
            ],
            labels : [1, 2, 3, 4, 5, 6, 7, 8]
        })
    }, []);


    return (
        <>
            <div className="chart-box">
                <Chart data={data}
                       barPercentage={0.6}
                       categoryPercentage={0.4}
                       barRadius={15}
                       gridX={false}
                       gridY={false}
                       borderX={false}
                       borderY={false}
                       axisDisplay={false}
                       legendFont={'sf-medium'}
                       paddingTop={0} labelSize={20} paddingLeft={0}/>
            </div>
            
            <ul className="sf-medium flex hr-space-around margin-t-20 padding-lr-10">
                <li>
                    <div className="number font-26 green-color margin-b-5">649</div>
                    <div className="font-16">FCW
                        <div className='tooltip'>Forward Collision Warning</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 red-color margin-b-5">189</div>
                    <div className="font-16">PCW
                        <div className='tooltip'>Pedestrian Collision Warning</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 green-color margin-b-5">1.6k</div>
                    <div className="font-16">LDW
                        <div className='tooltip'>Lane Departure Warning</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 red-color margin-b-5">738</div>
                    <div className="font-16">HA
                        <div className='tooltip'>Harsh Acceleration</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 red-color margin-b-5">699</div>
                    <div className="font-16">HB
                        <div className='tooltip'>Harsh Braking</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 green-color margin-b-5">451</div>
                    <div className="font-16">DIS
                        <div className='tooltip'>Distracted</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 red-color margin-b-5">2k</div>
                    <div className="font-16">HMW
                        <div className='tooltip'>Headway Monitoring</div>
                    </div>
                </li>
                <li>
                    <div className="number font-26 green-color margin-b-5">201</div>
                    <div className="font-16">DRW
                        <div className='tooltip'>Drowsy</div>
                    </div>
                </li>
            </ul>
        </>
    )
}

export default DashCompareChart;
